import styled from "styled-components";

export const Container = styled.div`
  margin-top: 80px;
  padding: 20px;
  display: flex;
  justify-content: center;
  min-height: 80vh;
`;

export const PoolListWrapper = styled.div`
  width: 80%;
  @media (max-width: 768px) {
    width: 95%;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h2`
  margin: 0;
`;

export const Button = styled.button`
  background: #0077ff;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background: #005fcc;
  }
`;

export const PoolList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 20px;
`;

export const PoolCard = styled.li`
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
`;

export const PoolTitle = styled.a`
  font-weight: bold;
  font-size: 1.1rem;
  text-decoration: none;
  color: #333;
`;

export const Meta = styled.div`
  font-size: 0.9rem;
  color: #666;
  margin-top: 6px;
`;

export const Actions = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 8px;
`;

export const Input = styled.input`
  margin-left: 12px;
  flex: 1;
  padding: 6px;
`

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Modal = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
`;

export const Label = styled.label`
  display: block;
  margin: 10px 0;
`;

export const CheckboxRow = styled.div`
  display: flex;
  gap: 12px;
  margin: 10px 0;
`;

export const ErrorMsg = styled.div`
  color: red;
  margin-top: 8px;
`;
